import { createFlatKey } from '../../lib/addresses';
import { urlKeys } from './config';

const getGroupClientByPhone =
  ({ clientsByPhone, flat }) =>
  (client) => {
    const clientWithFlat = { ...client, flatInfo: flat };

    const { phone } = client;

    if (phone) {
      !clientsByPhone[phone]
        ? (clientsByPhone[phone] = [clientWithFlat])
        : clientsByPhone[phone].push(clientWithFlat);
    }
  };

const getFlatsSelect =
  ({ withClientsByPhone }) =>
  (data) => {
    if (!data || data === 'Error') return data;

    const clientsByPhone = {};
    const flatsByTypeAndName = {};

    data.forEach((flat) => {
      const { clients, address } = flat;
      const { typeId, name } = address || {};

      const key = createFlatKey({ typeId, name });
      flatsByTypeAndName[key] = flat;

      if (withClientsByPhone) {
        const groupClientByPhone = getGroupClientByPhone({
          clientsByPhone,
          flat,
        });
        clients.forEach(groupClientByPhone);
      }
    });

    const result = { flatsByTypeAndName };

    if (withClientsByPhone) {
      result.clientsByPhone = clientsByPhone;
    }

    return result;
  };

// const getMetersSelect = () => (data) => {
//   if (!data || data === 'Error') return data;

//   const meterSerialNumbers = new Set();

//   data.forEach((meter) => {
//     meterSerialNumbers.add(meter.serialNumber);
//   });

//   return { meterSerialNumbers };
// };

export const querySelectGetter = {
  [urlKeys.flats]: getFlatsSelect,
  // [urlKeys.meters]: getMetersSelect,
};
